import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import PostumoImg from "../../assets/images/postumo-img.webp";
import { LiaQrcodeSolid } from "react-icons/lia";
import "./MemorialPostumo.css";

export default function MemorialPostumo(props) {
  return (
    <Container className="postumo-section">
      <Row>
        <Col className="postumo-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <LiaQrcodeSolid
              style={{ color: props.iconColor }}
              className="postumo-icon"
            />{" "}
            MEMORIAL PÓSTUMO
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="postumo-third-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Acesso exclusivo para titulares do contrato ao painel de controle da
            sua placa inteligente. Gerencie o conteúdo, fotos e a linha do tempo
            com os acontecimentos mais importantes em vida.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href="https://memorialpostumo.com.br/"
            rel="noopener noreferrer"
            target="_blank"
            icon=""
            content="ACESSE O PAINEL"
            backgroundColor={props.primaryBtnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={20}
            width={240}
            borderColor={props.primaryBtnColor}
            disabled={false}
          />
        </Col>
        <Col lg={{ span: 6, order: "first" }} className="postumo-second-col">
          <div className="postumo-img-container">
            <img src={PostumoImg} alt="Celular Memorial Póstumo" />
            <div className="postumo-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
